import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import { OutsideAlerter } from '../../../utils/useOutsideDetector';
import { Actions, IconWrapper } from './style';

const MultiActions = ({ actions }) => {
  const [showActions, setShowActions] = useState(false);
  return (
    <IconWrapper
      onClick={(e) => {
        e.stopPropagation();
        setShowActions(!showActions);
      }}
    >
      <Icon type="dots-vertical" size={30} />
      {showActions && (
        <Actions
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <OutsideAlerter onClick={() => setShowActions(false)}>
            {(actions || []).map((action, i) => (
              <div
                key={`action-${i}`}
                className="action"
                onClick={action?.onClick}
              >
                <Icon type={action?.icon} fill={action?.fill} size={16} />
                <span>{action?.label}</span>
              </div>
            ))}
          </OutsideAlerter>
        </Actions>
      )}
    </IconWrapper>
  );
};

MultiActions.propTypes = {
  actions: PropTypes.array.isRequired,
};

export default MultiActions;
